<template>
  <div>
    <h3 class="mb-4">{{$t("message.payment_history")}}</h3>
    <div class="table-responsive">
        <table class="table table-bordered">
            <thead class="table-dark">
            <tr>
                <th class="text-center align-middle" style="width:40px;">#</th>
                <th>{{$t("message.invoice_number")}}</th>
                <th class="text-center align-middle">{{$t("message.transaction_id")}}</th>
                <th class="text-center align-middle">{{$t("message.total")}}</th>
                <th class="text-center align-middle">{{$t("message.currency")}}</th>
                <th class="text-center align-middle">{{$t("message.payment_option")}}</th>
                <th class="text-center align-middle">{{$t("message.paid_date")}}</th>
                <th class="text-center align-middle">{{$t("message.action")}}</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in payments" :key="index">
                    <td class="text-center">{{index+1}}</td>
                    <td>{{item.invoice_number}}</td>
                    <td class="text-center">{{item.transaction_id}}</td>
                    <td class="text-center">{{fomartTotal(item.total_amount)}}</td>
                    <td class="text-center">{{item.currency}}</td>
                    <td class="text-center">{{getPaymentOptionName(item.payment_method)}}</td>
                    <td class="text-center">{{item.paid_at}}</td>
                    <td class="text-center">
                        <button class="btn btn-dark" @click="goToPrintInvoice(item.transaction_id)"><i class="fas fa-print"></i></button>
                        <!-- <router-link class="btn btn-dark" :to="{name:'printInvoice',params:{transactionId:item.transaction_id}}"><i class="fas fa-print"></i></router-link> -->
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>
<script>
import axios from "@/axios";
import { mapGetters } from "vuex";
export default {
    setup() {
        return {};
    },
    data() {
        return {
            payments: [],
        };
    },
    methods: {
        showLoader() {
            return this.$loading.show({
                container: this.$refs.formContainer,
                color: "#01B201",
                canCancel: true,
                onCancel: this.onCancelLoader
                });
        },
        goToPrintInvoice(v){
            let routeData = this.$router.resolve({name:'printInvoice',params:{transactionId:v}});
            window.open(routeData.href, '_blank');
        },
        async loadPaymentHistory(){
            let loader = this.showLoader();
            const respone = await axios.get("get-payment-history", {
                headers: {
                Authorization: "Bearer " + this.$store.getters.getAuthToken
                }
            });
            if (respone.status == 200) {
                this.payments = respone.data.data;
                //console.log("this data member:",respone.data);
            }
            loader.hide();
        },
    },
    computed :{
        ...mapGetters([
            'getParticipant'
        ]),
        getBusinessType(){
            return (t) =>{
                switch (t){
                    case '1':
                    case 1:
                        return this.$t("message.stock_business");
                    case '2':
                    case 2:
                        return this.$t("message.derivative_business");
                    case '19':
                    case 19:
                        return this.$t("message.public") + ' - ' + this.$t("message.stock_business");
                    case 20:
                    case '20':
                        return this.$t("message.public") + ' - ' + this.$t("message.derivative_business");
                    default:
                        return t;
                }
            }
        },
        getPaymentOptionName(){
            return (t) =>{
                switch (t){
                    case 'cards':
                        return 'Credit/Debit Card';
                    case 'abapay':
                        return 'ABA PAY';
                    case 'bakong':
                        return 'KHQR';
                    default:
                        return t;
                }
            }
        },
        fomartTotal(){
            return (n) => {
                return Number((n).toFixed(1)).toLocaleString();
            }
        }
    },
    created() {
        this.loadPaymentHistory();
    },
    mounted() {}
}
</script>

<style scoped>
    .nopadding{
        padding: 0;
        margin: 0;
    }
    .pb{
        padding-bottom: calc(100vh - 90vh);
    }
</style>